@if (noAllocation) {
<div class="alert alert-info" role="alert">
    No Authorization Allocation found for the selected filters.
</div>
} @else {
<section class="overview">
    <!-- Labels the hero's amount columns; hidden per-row labels cover the stacked layout. -->
    <div class="summary-header">
        <span class="col-head col-head--budgeted">Budgeted</span>
        <span class="col-head col-head--spent">Spent</span>
        <span class="col-head col-head--used">Used</span>
    </div>

    <!--
      The hero opens the plan-wide allocation drilldown. The cue below the figure
      is a plain span, not a button, so the row stays a single focusable control.
    -->
    <div class="hero" [ngClass]="severity(percentUsed)" tabindex="0" role="button"
        aria-label="View allocation details for this spending plan" (click)="allDetailsSelect.emit()"
        (keydown.enter)="allDetailsSelect.emit()"
        (keydown.space)="$event.preventDefault(); allDetailsSelect.emit()">
        <div class="hero-figure">
            <p class="hero-label">Available to use</p>
            <p class="hero-value">{{ available | currency }}</p>
            <span class="hero-cue">View allocation details</span>
        </div>

        <span class="amount amount--budgeted">
            <span class="amount-label">Budgeted</span>{{ totalBudgeted | currency }}
        </span>
        <span class="amount amount--spent">
            <span class="amount-label">Spent</span>{{ totalSpent | currency }}
        </span>
        <span class="amount amount--used">
            <span class="amount-label">Used</span>
            {{ percentUsed === null ? '—' : (percentUsed | number:'1.2-2') + '%' }}
        </span>

        <div class="hero-meter">
            <div class="meter" role="img"
                [attr.aria-label]="(totalSpent | currency) + ' of ' + (totalBudgeted | currency) + ' used'">
                @if (meterWidth(percentUsed) > 0) {
                <div class="meter-fill" [style.width.%]="meterWidth(percentUsed)"></div>
                }
            </div>
            <p class="meter-caption">
                @if (percentUsed === null) {
                No budget allocated
                } @else {
                {{ spentCurrentMonth | currency }} spent this month
                }
            </p>
        </div>
    </div>

    <!--
      A single category restates the totals above, so only its name is worth
      keeping - the figures would be the same numbers twice, and the hero already
      carries the drilldown.
    -->
    <div class="category-head">
        <h4 class="category-title">By category</h4>
    </div>

    <!--
      No per-category meters: each would be normalised to its own budget, so a
      small category could draw a longer bar than a large one. The figures carry
      it instead, side by side.
    -->
    <div class="category-strip">
        @for (row of categoryBreakdown; track row.name) {
        <div class="category-item" [ngClass]="severity(row.percentUsed)" tabindex="0" role="button"
            [attr.aria-label]="'View allocation details for ' + row.name" (click)="categorySelect.emit(row)"
            (keydown.enter)="categorySelect.emit(row)"
            (keydown.space)="$event.preventDefault(); categorySelect.emit(row)">
            <p class="item-name">{{ row.name }}</p>
            <p class="item-amounts">
                {{ row.spent | currency }} <span class="item-of">of</span> {{ row.budgeted | currency }}
            </p>
            <p class="item-used">
                <span class="severity-dot" aria-hidden="true"></span>
                @if (row.percentUsed === null) {
                No budget
                } @else {
                {{ row.percentUsed | number:'1.2-2' }}% used
                }
            </p>
        </div>
        }
    </div>
</section>
}
